export const WorkflowConfigurationUrls = {
    getWorkflowConfigurations: "WorkflowConfiguration/GetWorkflowConfigurations",
    getActivityMetadata: "WorkflowConfiguration/GetActivityMetadata",
    getWorkflowConfiguration: "WorkflowConfiguration/GetWorkflowConfiguration",
    saveWorkflowConfiguration: "WorkflowConfiguration/SaveWorkflowConfiguration",
    cloneWorkflowConfiguration: "WorkflowConfiguration/CloneWorkflowConfiguration",
    deleteWorkflowConfiguration: "WorkflowConfiguration/DeleteWorkflowConfiguration",
    accept: "WorkflowConfiguration/Accept",
    getEntityTypesForWorkflow: "WorkflowConfiguration/GetEntityTypesForWorkflow"
}
